import { changePasswordHeaderStyles } from "@insite/content-library/Widgets/ChangePassword/ChangePasswordHeader";
import { css } from "styled-components";

Object.assign(changePasswordHeaderStyles, {
    ...changePasswordHeaderStyles,
    title: {
        variant: "h1",
        css: css`
            font-family: OpenSans;
            font-size: 36px;
            color: #252525;
            border-bottom: none;
            text-transform: none;
        `,
    },
    buttonGridItem: {
        css: css`
            justify-content: flex-end;
            align-items: flex-end;
        `,
        width: [12, 12, 4, 3, 3],
    },
});
